<template>
  <v-app id="inspire">
    <v-content class="zh-content">
      <v-container class="fill-height" fluid >
        <!-- <v-layout column> -->
        <v-layout>
        <CustomLogin />
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import zhConfig from '../../zh.config'
export default {
  components: {
    // 按照使用者設定的 mode 注入 Login 頁面
    CustomLogin: () => import('../mode/' + zhConfig.loginMode + '/components/Login.vue')
  }
}
</script>

<style lang="scss" scoped>
.zh-content {
  // background-image: linear-gradient(#f0aa00, #ffffff);
  background-image: linear-gradient(rgb(248, 220, 150), #ffffff);  
}
.height {
  
  height : 100vh;
}
</style>
